module.exports = __webpack_public_path__ + "be09464aa0b2f35cd601a0e2e47bf029.MP3";